import { Divider, Flex, Gap, Typography } from "../../../../ppui"
import { formatToDDMMYYYY, getDateProperFormatForInput } from "../../../../utils/common"
import { OrganizationBx, OrganizationEmDetails } from "../../../style"
import useOrganizationView from "../organization.service"

const OrganizationProfileForAdmin = ()=>{
    const {
        basicInformation,
        getOrganizationCategoryName,
        getOrganizationIndustryType,
        
        // getStateName
    } = useOrganizationView()

    return <>
              <Flex justifyContent="space-between" gap={"10"}>
                <Typography variant="h5" mb={"0"}>
                  Organization Details
                </Typography>
    
                
              </Flex>
              <Gap height={30} />
              <OrganizationEmDetails>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Organization Category
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {getOrganizationCategoryName(basicInformation?.registration_type) || 'N/A'}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Industry Type
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {getOrganizationIndustryType(basicInformation?.industry_type) || 'N/A'}
                  </Typography>
                </OrganizationBx>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Organization PAN
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.pan || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Organization TAN
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.tan_no || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Date Of Establishment
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.date_of_org ? formatToDDMMYYYY(new Date(getDateProperFormatForInput(basicInformation?.date_of_org))) : 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Payment Type
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {
                      basicInformation?.payment_type &&   basicInformation?.payment_type.join(', ')
                    }
                  </Typography>
                </OrganizationBx>
                {basicInformation?.wages_type &&
                  <OrganizationBx>
                    <Typography variant="body2" mb={"0"}>
                      Wages Type
                    </Typography>
                    <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                      {basicInformation?.wages_type ? basicInformation?.wages_type === "fixed_date" ? "Fixed Days" : "Monthly" : "N/A"
                      }
                    </Typography>
    
                  </OrganizationBx>}
                {basicInformation?.wages_days &&
                  <OrganizationBx>
                    <Typography variant="body2" mb={"0"}>
                      Wages Days
                    </Typography>
                    <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                      {basicInformation?.wages_days}
                    </Typography>
    
                  </OrganizationBx>}
              </OrganizationEmDetails>
    
              
              <Divider gap={20} />
              <Flex justifyContent="space-between" gap={"10"}>
                <Typography variant="h5" mb={"0"}>
                  Organization Address
                </Typography>
    
              </Flex>
              <Gap height={30} />
              <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                {/* {basicInformation?.address }, {basicInformation?.city || 'N/A'}, State, India, {basicInformation?.pincode}, {basicInformation?.locality}, {basicInformation?.landmark} */}
              </Typography>
              <OrganizationEmDetails>
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Address
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.address || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    City/District
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.city || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    State
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {/* {getStateName(basicInformation?.state)} */}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Country
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    India
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Pin Code
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.pincode || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Locality
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.locality || 'N/A'}
                  </Typography>
                </OrganizationBx>
    
                <OrganizationBx>
                  <Typography variant="body2" mb={"0"}>
                    Landmark
                  </Typography>
                  <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                    {basicInformation?.landmark || 'N/A'}
                  </Typography>
                </OrganizationBx>
              </OrganizationEmDetails>
              <Divider gap={20} />
              <Flex justifyContent="space-between" gap={"10"}>
                <Typography variant="h5" mb={"0"}>
                  Organization Act
                </Typography>
              </Flex>
              <Gap height={30} />
              {basicInformation?.org_acts?.map((item, index) => (
                <>
                  <OrganizationEmDetails key={index}>
                    <OrganizationBx>
                      <Typography variant="body2" mb={"0"}>
                        Act Name
                      </Typography>
                      <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                        {item?.act_name || 'N/A'}
                      </Typography>
                    </OrganizationBx>
    
                    <OrganizationBx>
                      <Typography variant="body2" mb={"0"}>
                        Reg No.
                      </Typography>
                      <Typography variant="body1" mb={"0"} color="primary" textCase="capitalize">
                        {item?.reg_no || 'N/A'}
                      </Typography>
                    </OrganizationBx>
                  </OrganizationEmDetails>
                </>
              ))}
            </>
}

export default OrganizationProfileForAdmin